import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BannerModule } from '@design/layout/banner-layout/banner.module';
import { PhosphorIconComponent } from '@cintra-payroll-hr/components';
import { TestIdDirective } from '@design/core/test-id.directive';

@Component({
  selector: 'app-lost-phone-banner',
  templateUrl: './lost-phone-banner.component.html',
  styleUrl: './lost-phone-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BannerModule, PhosphorIconComponent]
})
export class LostPhoneBannerComponent {
  constructor() {}
}
